<template>
   <div :style="{'height': height}">
      <v-toolbar color="white" flat>
         <template v-if="title">
            <v-toolbar-title class="grey--text text--darken-1">{{title}}</v-toolbar-title>
            <v-divider class="mx-3 hidden-md-and-up" inset vertical></v-divider>
         </template>
         <v-spacer></v-spacer>

         <v-dialog max-width="500px" v-model="dialog">
            <v-btn @click="newBtnClick" class="mb-2" color="primary" dark flat icon slot="activator">
               <v-icon>fas fa-plus-circle</v-icon>
            </v-btn>
            <v-card flat>
               <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
               </v-card-title>

               <v-card-text>
                  <v-form autocomplete="nope" lazy-validation ref="aForm" v-model="validForm">
                     <v-container grid-list-md>
                        <v-layout wrap>
                           <slot :data="editedItem" name="editForm"></slot>
                        </v-layout>
                     </v-container>
                  </v-form>
               </v-card-text>

               <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="close" color="blue darken-1" flat>Cancelar</v-btn>
                  <v-btn @click="save" color="blue darken-1" flat>Salvar</v-btn>
               </v-card-actions>

            </v-card>
         </v-dialog>
      </v-toolbar>


      <v-data-table :headers="tableColumns" :items="tableData" :loading="isLoading"
                    :pagination.sync="pagination" :rows-per-page-items="rowsPerPageItems" disable-initial-sort
                    no-data-text="Clique no (+) para Cadastrar"
                    rows-per-page-text="" v-bind="$attrs" v-on="listeners">

         <!-- Pass on all named slots -->
         <slot :name="slot" :slot="slot" v-for="slot in Object.keys($slots)"/>

         <!-- Pass on all scoped slots -->
         <template :slot="slot"
                   slot-scope="scope" v-for="slot in Object.keys($scopedSlots).filter(s=> s !== 'item')">
            <slot :name="slot" v-bind="scope"/>
         </template>

         <template slot="items" slot-scope="props">
            <tr @click="rowClick(props.item)">
               <slot :data="props" name="rows"></slot>

               <td class="justify-center layout px-0">
                  <v-icon @click="editItem(props.item)" class="mr-2" small>
                     edit
                  </v-icon>
                  <v-icon @click="deleteItem(props.item)" small>
                     delete
                  </v-icon>
               </td>
            </tr>
         </template>

         <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
         </template>
         <!--<template slot="no-data" v-if="!$slots['no-data']">
            <v-alert :value="true" color="error" icon="warning">
               Sorry, nothing to display here :(
            </v-alert>
         </template>-->

      </v-data-table>
   </div>
</template>

<script>

   let numeral = require('numeral');

   export default {
      name: 'a-detail-grid',

      props: {
         title: {
            type: String,
            required: false
         },
         value: {
            required: false
         },
         api: {
            type: String,
            required: false,
            default: 'dataService'
         },
         obj: {
            type: String,
            required: false
         },
         objId: {
            type: Number,
            required: false
         },
         parentKey: {
            type: Object,
            default: () => {
            }
         },
         filterBy: {
            type: Object,
            required: false
         },
         data: {
            type: Array,
            required: false,
            default: () => []
         },
         dataKey: {
            type: String,
            required: false,
            default: 'id'
         },
         columns: {
            type: Array,
            required: false,
            default: () => []
         },
         pager: {
            type: Object,
            required: false
         },
         rowsPerPageItems: {
            type: Array,
            required: false,
            default: (val) => {
               return val || [5, 20, 50];
            }
         },
         options: {
            type: Object,
            required: false
         },
         summary: {
            type: Array,
            required: false
         },
         summarySelect: {
            type: Array,
            required: false
         },
         height: {
            required: false,
            default: 500
         },
         multiSelect: {
            type: Boolean,
            required: false,
            default: false
         },
         newItemData: {
            type: Object,
            default: () => {
            }
         }
      },

      data () {
         return {
            validForm: false,
            isLoading: false,
            dialog: false,
            pagination: Object.assign({}, { rowsPerPage: 5 }, this.pager),
            tableData: [],
            tableColumns: [],
            editedIndex: -1,
            editedItem: {},
            defaultItem: this.newItemData
         };
      },

      computed: {
         formTitle () {
            return this.editedIndex === -1 ? 'Novo' : 'Alterar';
         },
         listeners () {
            return {
               ...this.$listeners
            };
         },
         filter () {
            return Object.assign({}, this.filterBy, this.parentKey);
         },
         parentKeyValue () {
            let k = Object.keys(this.parentKey)[0];
            return this.parentKey[k];
         }
      },

      watch: {
         dialog (val) {
            val || this.close();
         },
         filterBy () {
            this.loadData();
         },
         newItemData: {
            handler (val) {
               // console.log('watch: ', val);
               this.defaultItem = val;
               this.editedItem = this.$util.objectCopy(val);
            },
            deep: true
         }
      },

      created () {
         this.initialize();
         // console.log('created:', this.newItemData);
      },

      methods: {
         loadData () {
            if (this.data && this.data.length) {
               this.tableData = JSON.parse(JSON.stringify(this.data));
               this.$emit('onDataLoaded', JSON.parse(JSON.stringify(this.tableData)));
               this.$emit('onChange', JSON.parse(JSON.stringify(this.tableData)));
            } else if (this.api && this.obj) {
               this.isLoading = true;
               this.getApiData()
                  .then((data) => {
                     data = (data === null) ? [] : JSON.parse(JSON.stringify(data));
                     this.tableData = data;
                     this.$emit('onDataLoaded', JSON.parse(JSON.stringify(this.tableData)));
                     this.$emit('onChange', JSON.parse(JSON.stringify(this.tableData)));
                  })
                  .catch((err) => console.log('Detail GRID API ERROR: ', err))
                  .finally(() => this.isLoading = false);
            }
         },

         getApiData (textFilter) {
            let params = (this.filter) ? Object.assign({}, this.filter, { text: textFilter }) : textFilter;
            // console.log(params);
            return this.$api[this.api].search(this.obj, params);
         },

         initialize () {
            if (this.columns && !this.columns.find(i => i.value === this.dataKey)) {
               let tc = JSON.parse(JSON.stringify(this.columns));
               // console.log('Adding datakey column for unique identification of a row.');
               tc.push({
                  text: '',
                  value: this.dataKey
               });
               // console.log(JSON.stringify(tc));
               this.tableColumns = tc;
            }

            this.loadData();

         },

         newBtnClick () {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.$emit('onNewRow', JSON.parse(JSON.stringify(this.defaultItem)));
         },

         editItem (item) {
            
            this.editedIndex = this.tableData.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
         },

         deleteItem (item) {
            const index = this.tableData.indexOf(item);
            console.log(item[this.dataKey]);
            this.$msg.confirm({
               title: this.$t('appMsg.deleteConfirm'),
               message: `${this.$t('appMsg.delete')} ${item.payerName} dos pagadores`,
               icon: 'warning',
               actions: [this.$t('appMsg.yes'), this.$t('appMsg.dontDelete')],
               defaultAction: 1
            }).then((action) => {
               if (action === 0) {
                  this.$api[this.api].destroy(this.obj, item[this.dataKey]).then(() => {
                     this.tableData.splice(index, 1);
                     this.$emit('onChange', this.$util.objectCopy(this.tableData), this.$util.objectCopy(item));
                  });
               }
            });
         },

         close () {
            this.dialog = false;
            setTimeout(() => {
               this.editedItem = Object.assign({}, this.defaultItem);
               this.editedIndex = -1;
            }, 300);
         },

         parseValues (data) {
            let parsed = {};

            let parseNumber = (val) => numeral(val).value();

            let valueParser = (field) => {
               let fn = this.columns.find(c => c.value === field && c.hasOwnProperty('valueParser'));
               if (fn) {
                  return fn.valueParser;
               }

               return null;
            };

            let valueType = (field, value) => {
               let fn = this.columns.filter(c => c.value === field && c.hasOwnProperty('dataType'));
               if (fn.length) {
                  switch (fn[0].dataType) {
                     case 'number':
                        return parseNumber(value);
                  }
               }

               return value;

            };

            if (data) {
               Object.keys(data).forEach(k => {
                  let fn = valueParser(k);
                  parsed[k] = (fn) ? fn.call(this, data[k]) : valueType(k, data[k]);
               });
            }

            return parsed;

         },

         async save () {

            if (!this.$refs.aForm.validate()) {
               return;
            }

            let item = this.parseValues(this.editedItem);

            if (this.editedIndex > -1) { //EDITED ROW
               if (this.obj && this.parentKeyValue) {
                  let record = Object.assign(item, this.parentKey);
                  await this.$api[this.api].save(this.obj, record, record.id)
                     .then((data) => Object.assign(this.tableData[this.editedIndex], data));
               } else {
                  Object.assign(this.tableData[this.editedIndex], item);
               }
            } else { //INSERTED ROW
               if (this.obj && this.parentKeyValue) {
                  let record = Object.assign(item, this.parentKey);
                  await this.$api[this.api].save(this.obj, record)
                     .then((data) => this.tableData.unshift(data));
               } else {
                  this.tableData.unshift(item);
               }
            }

            this.$emit('onChange', this.$util.objectCopy(this.tableData), this.$util.objectCopy(item));
            this.close();
         },

         rowClick (item) {
            this.$emit('onRowClick', JSON.parse(JSON.stringify(item)));
         }

      }
   };
</script>

<style scoped>


</style>


// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/components/ADetailGrid.vue